import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export class ConfigError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ConfigError';
  }
}

function assertConfig() {
  if (!url || !anonKey || url.includes('your-project') || anonKey.includes('your-anon-key')) {
    const message =
      'Configurazione Supabase mancante. Copia .env.example in .env e imposta VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY.';
    console.error(`[Metis] ${message}`);
    throw new ConfigError(message);
  }
}

let client;

export function getSupabase() {
  if (!client) {
    assertConfig();
    client = createClient(url, anonKey);
  }
  return client;
}

export async function getSession() {
  const { data, error } = await getSupabase().auth.getSession();
  if (error) throw error;
  return data.session;
}

export function onAuthStateChange(callback) {
  const { data } = getSupabase().auth.onAuthStateChange((_event, session) => {
    callback(session);
  });
  return data.subscription;
}

export async function signIn(email, password) {
  const { data, error } = await getSupabase().auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data.session;
}

export async function signUp(email, password) {
  const { data, error } = await getSupabase().auth.signUp({ email, password });
  if (error) throw error;
  return data.session;
}

export async function signOut() {
  const { error } = await getSupabase().auth.signOut();
  if (error) throw error;
}

export function getUserId(session) {
  return session?.user?.id ?? null;
}

export function getUserEmail(session) {
  return session?.user?.email ?? null;
}
